<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items="desserts"
            :items-per-page="10"
            class="elevation-1"
        >
            <template v-slot:top>
                <v-col cols="4">
                    <v-select label="กลุ่มงานบริการ" :items="groups">
                </v-select>
                </v-col>
            </template>
        </v-data-table>
    </v-container>
  
</template>

<script>
export default {
    name: "Data2_1",
    data: () => ({
        groups: ["กลุ่มงาน จ3"],
        headers: [
            {text: 'วัน', value: 'day'},
            {text: 'วันที่', value: 'date'},
            {text: 'จำนวนทั้งหมด', value: 'total'},
            {text: 'จำนวนคนตรงเวลา', value: 'onTime'},
            {text: 'จำนวนคนตรงเวลา', value: 'percentOnTime'},
            {text: 'จำนวนมาก่อนเวลา', value: 'beforTime'},
            {text: 'จำนวนมาก่อนเวลา', value: 'percentBeforeTime'},
            {text: 'จำนวนสาย', value: 'late'},
            {text: 'จำนวนสาย', value: 'percentLate'},
            {text: 'จำนวนไม่มา', value: 'notComing'},
            {text: 'จำนวนไม่มา', value: 'percentNotComing'},
            ],
        desserts: [
            {'day': 'จันทร์', 'date': '01/03/2021', 'total': 201, 
             'onTime': 44, 'percentOnTime': '21.89%', 
             'beforTime': 56, 'percentBeforeTime': '27.86%',
             'late':45, 'percentLate': '22.39%',
             'notComing': 56, 'percentNotComing': '27.86%'
            },
            {'day': 'อังคาร', 'date': '02/03/2021', 'total': 62, 
             'onTime': 22, 'percentOnTime': '35.48%', 
             'beforTime': 16, 'percentBeforeTime': '25.81%', 'late':22, 'percentLate': '35.48%', 'notComing': 2, 'percentNotComing': '3.23%'
            },
            {'day': 'พุธ', 'date': '03/03/2021', 'total': 51, 
             'onTime': 28, 'percentOnTime': '59.90%', 
             'beforTime': 5, 'percentBeforeTime': '9.80%', 'late':3, 'percentLate': '5.88%', 'notComing': 15, 'percentNotComing': '29.41%'
            },
            {'day': 'พฤหัส', 'date': '04/03/2021', 'total': 64, 
             'onTime': 32, 'percentOnTime': '50.00%', 
             'beforTime': 14, 'percentBeforeTime': '21.88%', 'late':8, 'percentLate': '12.50%', 'notComing': 10, 'percentNotComing': '15.63%'
            },
            {'day': 'ศุกร์', 'date': '05/03/2021', 'total': 262, 
             'onTime': 98, 'percentOnTime': '37.40%', 
             'beforTime': 20, 'percentBeforeTime': '7.63%', 'late':55, 'percentLate': '20.99%', 'notComing': 89, 'percentNotComing': '33.97%'
            },
            {'day': 'เสาร์', 'date': '06/03/2021', 'total': 191, 
             'onTime': 106, 'percentOnTime': '55.50%', 
             'beforTime': 32, 'percentBeforeTime': '16.75%', 'late':41, 'percentLate': '21.47%', 'notComing': 12, 'percentNotComing': '6.28%'
            },
            {'day': 'อาทิตย์', 'date': '07/03/2021', 'total': 30, 
             'onTime': 19, 'percentOnTime': '63.33%', 
             'beforTime': 7, 'percentBeforeTime': '23.33%', 'late':3, 'percentLate': '10.00%', 'notComing': 1, 'percentNotComing': '3.33%'
            }
        ]
    })
}
</script>